import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import { FC } from 'react';
import styled from './index.module.scss';

interface MinTitleProps {
    title: string;
    // 对齐方式：'left' | 'center' | 'right'
    align?: 'left' | 'center' | 'right';
}

const MinTitle: FC<MinTitleProps> = ({ title, align = 'center' }) => {
    const { locale } = getLocal();
    const { t } = useLang('theProduct.Plug');

    return (
        <div className={`${styled.MinTitle} MinTitleAA`}>
            <p className={`min_title ${align}`}>{title}</p>
        </div>
    );
};

export default MinTitle;
